import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { InlineFilters } from 'features/command-center';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import strings from 'strings';
import { FPIcon } from 'UI/components/atoms';
import { SvgInformationCircle } from 'UI/res';

import { CommissionsBoardSheets, CommissionsBoardTransactions } from './components';
import { useCommissionsBoard } from './hooks';

export const CommissionsBoard = () => {
  const {
    extraFilters,
    handleClickSheetsRow,
    handleFiltersChange,
    hasSuperiorRole,
    isOnlyRecruiter,
    queryParams,
    selectedPayPeriodId
  } = useCommissionsBoard();

  const INLINE_FILTERS = [
    ...[isOnlyRecruiter ? '' : 'employeeNumbers'],
    ...[isOnlyRecruiter ? '' : 'employeeStatuses'],
    ...[hasSuperiorRole ? 'teams' : '']
  ];

  return (
    <>
      <InlineFilters
        filters={INLINE_FILTERS}
        extraFilters={extraFilters}
        onFiltersChange={handleFiltersChange}
        persistenceKey={INLINE_FILTERS_KEYS.financial.commissionsBoard}
      />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gap={2}>
            <FPIcon
              aria-label="Info"
              component={SvgInformationCircle}
              onSetColor={palette => palette.info.main}
              role="img"
              size={18}
            />
            <Typography variant="caption">
              &nbsp;{strings.commandCenter.commissionsBoard.updatedInfo}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <CommissionsBoardSheets
              onClickRow={handleClickSheetsRow}
              queryParams={queryParams}
              selectedRowId={selectedPayPeriodId}
            />
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <CommissionsBoardTransactions
              key={selectedPayPeriodId}
              queryParams={queryParams}
              selectedPayPeriodId={selectedPayPeriodId}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};
